import { useEffect, useRef, useState } from "react";
import I18n from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";

interface TextFilterProps {
  onChange: (value: string) => void;
}

export const TextFilter = ({ onChange }: TextFilterProps) => {
  const [value, setValue] = useState("");
  const EnterKey = "Enter";
  const ref = useRef<HTMLInputElement>(null);

  const handleSubmit = () => {
    onChange(value);
  };

  const handleKeypress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === EnterKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  useEffect(() => {
    ref.current?.focus();
  }, [ref]);

  return (
    <>
      <input
        ref={ref}
        type="text"
        value={value}
        onChange={e => setValue(e.target.value)}
        onKeyPress={handleKeypress}
        className="form-control form-control--sm placeholder:text-light placeholder:opacity-100"
      />
      <div className="mt-3">
        <Button variant="primary" onClick={handleSubmit}>
          {I18n.t("members_directory.header.search.apply_filter")}
        </Button>
      </div>
    </>
  );
};
